import { sortBreakpoints } from './sortBreakpoints';
/**
 * Get smallest breakpoint key
 */
export function getSmallestBreakpoint(breakpoints) {
    var sortedBreakpoints = sortBreakpoints(breakpoints);
    return sortedBreakpoints[sortedBreakpoints.length - 1].name;
}
//# sourceMappingURL=getSmallestBreakpoint.js.map